<template>
	<div class="ms-cell-editor">
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{ 'edit-disabled': readOnly, 'ms-editor-text': editable }"
		>
			<div class="editor-display">
				<span>{{
					dataRow[col.dataField] | formatData({ formatType: col.formatType })
				}}</span>
			</div>

			<div
				class="icon-input float-right"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-20 mi-icon-error mr-2"></div>
			</div>
		</div>
		<ms-dropdown
			ref="dropdown"
			class="w-full h-full bg-white"
			type="button"
			btnType="secondary"
			:animation="false"
			v-if="isSelected && !readOnly"
			:title="
				dataRow[col.dataField] | formatData({ formatType: col.formatType })
			"
		>
			<component
				:is="col.templateDropdown"
				:dataRow="dataRow"
				v-bind="col.dropdownProperty"
				@close="closeDropdownMenu"
				@accept="acceptDropdownMenu"
				@tabend="$emit('next')"
				ref="templateDropdown"
			></component>
		</ms-dropdown>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
export default {
	name: 'msCellDropdown',
	extends: msCellInput,
	methods: {
		//Sự kiện click vào cell editor
		cellSelected() {
			const me = this;
			me.isSelected = true;
			me.$nextTick(() => {
				me.focusHandler();
			});
		},
		focusHandler(e) {
			const me = this;
			if (me.$refs.dropdown) {
				let col = me.col;
				if (
					me.$refs.templateDropdown &&
					typeof me.$refs.templateDropdown.afterShow == 'function'
				) {
					me.$refs.templateDropdown.afterShow();
				}
				if (
					me.$refs.dropdown.applyValidate &&
					typeof me.$refs.dropdown.applyValidate == 'function'
				) {
					me.$refs.dropdown.applyValidate(me.cellErrorProvider.message);
				}
				me.$ms.commonFunc.focusFirstControl(me.$el);
				setTimeout(() => {
					if (me.$refs.dropdown && !me.$refs.dropdown.showDropdownMenu) {
						me.$refs.dropdown.clickIcon();
						me.$nextTick(() => {
							me.$ms.commonFunc.focusFirstControlInput(
								me.$refs.templateDropdown.$el
							);
						});
					}
				}, 100);
			}
		},
		closeDropdownMenu() {
			const me = this;
			if (me.$refs.dropdown) {
				me.isSelected = false;
				me.$refs.dropdown.closeDropdownMenu();
			}
		},
		acceptDropdownMenu(data) {
			const me = this;
			let col = me.col;
			me.$set(me.dataRow, col.dataField, data);
			let editor = me.col.__editor;
			if (editor) {
				if (typeof editor.reset === 'function') {
					editor.reset();
				}
				if (typeof editor.setValue === 'function') {
					editor.setValue(me.dataRow[col.dataField]);
				}
			}
			me.closeDropdownMenu();
			me.$emit('next');
		},
	},
	watch: {
		isSelected: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == false) {
					me.validateCell();
					me.closeDropdownMenu();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
::v-deep .ms-button-dropdown {
	text-align: start;
}
</style>

